import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import IndustryInfo from '@/business-components/sale/IndustryInfo';
import AreaInfo from '@/business-components/sale/AreaInfo';
import PromotedObjectInfo from '@/business-components/sale/PromotedObjectInfo';
import ExternalLink from '@/components/ExternalLink';
import MpOpenInfo from '@/components/MpOpenInfo';
import LinkButton from '@/components/LinkButton';
import WithPermission from '@/common/permissions/WithPermission';
import { withApi } from '@tencent/react-aio';
import {
  leadStatusMap,
  REACT_APP_PUBLIC_URL,
  DIAL_OUT_RESULT_TYPE,
  LEAD_LAYER_TYPE,
  BUDGET_TYPE,
} from '@/constants/Constants';
import perms from '@/common/permissions/sale/perms';
import { withAccount } from '@/business-components/operator/account-context';
import { RenderLeadPromoteExperience } from '@/business-components/sale/LeadPromoteExperienceSelect';
import CleaningStatus from '@/components/CleaningStatus';
import DateTime from '@/components/DateTime';
import AttributionTeam from '@/business-components/sale/AttributionTeam';
import UserInfo from '@/business-components/sale/UserInfo';
import PotentialStatus from '@/components/PotentialStatus';
import { getCommonConfig } from '@/api/wuji';
import { OverlayTrigger, PopOver } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import CheckNewCustom from '@/business-components/sale/CheckNewCustom';

class CustomerPanel extends React.PureComponent {
  static propTypes = {
    lead: PropTypes.shape({
      leadId: PropTypes.number.isRequired,
      company: PropTypes.shape({
        companyName: PropTypes.string.isRequired,
        industryId: PropTypes.number.isRequired,
        areaId: PropTypes.number.isRequired,
        address: PropTypes.string,
      }).isRequired,
      intention: PropTypes.shape({
        adPlatformType: PropTypes.string.isRequired,
        promotedObject: PropTypes.string,
      }),
      memo: PropTypes.string,
      customerId: PropTypes.number,
      customerMpUserName: PropTypes.string,
      customerUnibdAppId: PropTypes.string,
    }).isRequired,
    readOnly: PropTypes.bool,
    onEdit: PropTypes.func,
    callback: PropTypes.func,
    isLead: PropTypes.bool, // 是否为线索详情
  }

  relatedLeadId = location.href.indexOf('potentials') > -1

  constructor(props) {
    super(props);
    this.state = {
      wujiConfig: {},
    };
  }

  componentDidMount() {
    this.getLeadStatus();
    const { isLead } = this.props;
    if (isLead) {
      getCommonConfig({ filter: 'key=leads_detail_expand' })
        .then((res) => {
          const { code, data = [] } = res;
          if (code === 200) {
            this.setState({ wujiConfig: data[0] });
          }
        });
    }
  }

  getLeadStatus = () => {
    const {
      webApi,
      lead: { relatedLeadId },
    } = this.props;
    if (relatedLeadId) {
      webApi
        .getLeadStatus(relatedLeadId)
        .ajax()
        .then((res) => {
          if (res) {
            this.setState({
              linkUrl: leadStatusMap[res.progressStatus],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  linkToDetail = () => {
    const {
      lead: { relatedLeadId },
    } = this.props;
    const { linkUrl } = this.state;
    if (linkUrl && relatedLeadId) {
      window.location.href = `${window.location.origin}${REACT_APP_PUBLIC_URL}/${linkUrl}/${relatedLeadId}`;
    }
  }

  /**
   * 拓展字段
   */
  renderExpandField = () => {
    const { lead: { extension } } = this.props;
    const { wujiConfig } = this.state;
    try {
      let expand = {};
      expand = extension ? JSON.parse(extension) : {};
      if (_.isObject(expand) && !_.isEmpty(expand)) {
        const list = JSON.parse(wujiConfig?.config).list;
        const field = _.filter(list.map((d) => {
          if (!_.isNil(expand[d.name]) && expand[d.name] !== '') {
            return <p>
                <span className="expand-key">
                  {d.label}
                  {
                    d.tip ? <OverlayTrigger
                      trigger="hover"
                      overlay={(
                          <PopOver>{d.tip}</PopOver>
                      )}
                    >
                      <i className="spaui-icon icon-help workbench-overlaytrigger"></i>
                    </OverlayTrigger> : null
                  }
                  ：
                </span>
                <span className="expand-val">{expand[d.name]}</span>
              </p>;
          }
        }), (v) => v);
        if (field.length > 0) {
          return <div className="expand-info">
            <p className="expand-title">拓展信息：</p>
            <div className="expand-field">
              {field}
            </div>
          </div>;
        }
        return null;
      }
    } catch {
      return null;
    }
    return null;
  }

  render() {
    const {
      readOnly,
      lead: {
        leadId,
        company,
        intention,
        memo,
        relatedLeadId,
        cleaningStatus,
        leadStateReasonTag,
        createdTime,
        dialOutResult,
        leadPromote,
        competitorTags,
        leadNewStore,
        leadLayerType,
        operationTags,
        budgetAmount,
        originalCustomerId,
      },
      ascriptionTeamId,
      ascriptionOwnerId,
      onEdit,
      isLead,
      detail: { taskProvideTime, potentialStatus, transactionProbability, onlineSalesTags = [] },
      account: { saleStatus },
      whiteList,
      showCheckNewCustom,
    } = this.props;
    const { agencyId } = saleStatus;
    return (
      <div className="CustomerPanel">
        <h1>
          {company.companyName}
          <IndustryInfo industryId={company.industryId} />
          <WithPermission reject={readOnly} oneOf={[perms.LEAD_EDIT_SELF, perms.LEAD_EDIT_GROUP, perms.LEAD_EDIT_ALL, perms.POTENTIAL_EDIT_SELF, perms.POTENTIAL_EDIT_GROUP, perms.POTENTIAL_EDIT_ALL]}>
            <LinkButton onClick={onEdit}>编辑</LinkButton>
          </WithPermission>
        </h1>
        <dl>
          <dt>线索 ID：</dt>
          <dd>{leadId}</dd>
          <dt>公司地址：</dt>
          <dd>
            <AreaInfo areaCode={company.areaId} /> {company.address}
          </dd>
          {this.relatedLeadId && (
            <React.Fragment>
              <dt>关联线索 ID：</dt>
              <dd>
                <a href="javascript:;" onClick={this.linkToDetail}>
                  {relatedLeadId}
                </a>
              </dd>
            </React.Fragment>
          )}
          <dt>公司官网：</dt>
          <dd>
            <ExternalLink href={company.homepageUrl} />
          </dd>
          <dt>推广目标：</dt>
          <dd>
            <PromotedObjectInfo promotedObject={intention} />
          </dd>
          <dt>公众号名称：</dt>
          <dd>
            {company.mpOpenName}
            {/* <MpOpenInfo mpOpenName={company.mpOpenName} /> */}
          </dd>
          <dt>跟进销售：</dt>
          <dd>
            <div>
              <UserInfo key={ascriptionOwnerId} userId={ascriptionOwnerId} />
            </div>
          </dd>
          <dt>所属团队：</dt>
          <dd>
            <div>
              <AttributionTeam ownerId={ascriptionOwnerId} ascriptionTeamId={ascriptionTeamId} />
            </div>
          </dd>
          <dt>状态：</dt>
          <dd>{isLead ? <CleaningStatus cleaningStatus={cleaningStatus} /> : <PotentialStatus potentialStatus={potentialStatus} transactionProbability={transactionProbability} />}</dd>
          {isLead ? (
            <React.Fragment>
              <dt>线索原因：</dt>
              <dd>{leadStateReasonTag}</dd>
            </React.Fragment>
          ) : null}
          <dt>线索导入时间：</dt>
          <dd>
            <DateTime dateTime={createdTime} />
          </dd>
          <dt>任务发放时间：</dt>
          <dd>
            <DateTime dateTime={taskProvideTime} />
          </dd>
          {
            isLead && _.includes(whiteList.data, agencyId) ? (
              <React.Fragment>
                <dt>智能外呼结果：</dt>
                <dd>{DIAL_OUT_RESULT_TYPE[dialOutResult]}</dd>
              </React.Fragment>
            ) : null
          }
          <dt>是否推广：</dt>
          <dd>
            <div>{leadPromote ? '是' : '否'}</div>
          </dd>
          <dt>推广经验：</dt>
          <dd>
            <RenderLeadPromoteExperience value={competitorTags} />
          </dd>
          <dt>是否新店：</dt>
          <dd>
            <div>{leadNewStore ? '是' : '否'}</div>
          </dd>
          <dt>线索分层：</dt>
          <dd>
            <div>{LEAD_LAYER_TYPE[leadLayerType]}</div>
          </dd>
          <dt>备注信息：</dt>
          <dd>
            <div>{memo}</div>
          </dd>
          <dt>运营标签：</dt>
          <dd>
            {operationTags?.map((item) => (
              <div style={{ display: 'flex', alignItems: 'center' }} key={item.leadTagId}>
                {item.leadTagName}
                <OverlayTrigger
                  overlay={<PopOver>{item.memo}</PopOver>}
                  placement='right'
                  alignment='bottom'
                >
                  <Icon name="help-filled" color="#14A3F5" style={{ width: 14, height: 14, marginLeft: 5, cursor: 'pointer' }} />
                </OverlayTrigger>
              </div>
            ))}
          </dd>
          <dt>留资客户预算：</dt>
          <dd>
            <div>{budgetAmount ? BUDGET_TYPE[budgetAmount] : ''}</div>
          </dd>
          <dt>留资客户账户：</dt>
          <dd>
            <div>{originalCustomerId}</div>
          </dd>
          {/* <dt>企微标签：</dt>
          <dd>
            <div>{_.isArray(onlineSalesTags) ? onlineSalesTags.join(',') : null}</div>
          </dd>
          */}
        </dl>
        {isLead && this.renderExpandField()}
        {!!showCheckNewCustom
          && <div style={{ paddingRight: '80px', textAlign: 'right' }}>
            <CheckNewCustom companyName={company.companyName} isDialog/>
          </div>
        }
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    whiteList: state.customerProtectionWhiteList,
  };
}

export default withApi(withAccount(connect(mapStateToProps, {})(CustomerPanel)));
